import { render, staticRenderFns } from "./closeWorkList.vue?vue&type=template&id=45b05d7c&scoped=true&"
import script from "./closeWorkList.vue?vue&type=script&lang=js&"
export * from "./closeWorkList.vue?vue&type=script&lang=js&"
import style0 from "./closeWorkList.vue?vue&type=style&index=0&id=45b05d7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b05d7c",
  null
  
)

component.options.__file = "closeWorkList.vue"
export default component.exports